<template>
    <div>
        <card-header title="Transactions" icon="fa-usd-circle" />

        <card-body>
            <card-list>
                <div v-if="loading" class="has-text-centered py-5">
                    <b-loading :is-full-page="false" v-model="loading" :can-cancel="false"></b-loading>
                </div>

                <div v-else-if="data.transactions.length === 0" class="has-text-centered py-5 has-text-grey-light">
                    <i class="fas fa-search fa-3x mb-3"></i>
                    <p>No transactions found for the selected filters</p>
                </div>

                <template v-else>
                    <app-transaction-tile
                        v-for="transaction in data.transactions"
                        :key="transaction.id"
                        :transaction="transaction"
                        :active="child && child.definition.component === 'transaction-detail' && parseInt(child.props.transactionId) === transaction.id"
                        @click="openDetail(transaction)"/>
                </template>
            </card-list>
        </card-body>

        <card-footer v-if="data.transactions.length > 0">
            <div class="has-text-grey">
                {{ data.transactions.length }} transaction<span v-if="data.transactions.length !== 1">s</span>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardFooter from "@/TIER/components/CardFooter";
    import AppTransactionTile from "@/components/tiles/AppTransactionTile";
    import {client as http} from "@/http_client";

    export default {
        components: {
            CardHeader,
            CardBody,
            CardList,
            CardFooter,
            AppTransactionTile
        },
        props: ['card', 'child', 'props'],
        data() {
            return {
                data: {
                    transactions: []
                },
                loading: true
            }
        },
        mounted() {
            this.loadTransactions();
        },
        watch: {
            props: {
                handler() {
                    this.loadTransactions();
                },
                deep: true
            }
        },
        methods: {
            reload() {
                this.loadTransactions();
            },

            loadTransactions() {
                this.$emit('loading', true);
                this.loading = true;

                // Split pipe-separated transaction types back into array
                let transactionTypes = [];
                if (this.props && this.props.transactionTypes) {
                    transactionTypes = this.props.transactionTypes.split('|').filter(t => t.length > 0);
                }

                const payload = {
                    startDate: this.props.startDate || null,
                    endDate: this.props.endDate || null,
                    transactionTypes: transactionTypes
                };

                http.post('transactions', payload).then(response => {
                    this.data = response.data;
                    this.loading = false;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.error('Error loading transactions:', err);
                    this.$buefy.toast.open({
                        message: 'Failed to load transactions',
                        type: 'is-danger'
                    });
                    this.loading = false;
                    this.$emit('loading', false);
                });
            },

            openDetail(transaction) {
                this.$openCard('transaction-detail', {transactionId: transaction.id}, this.card);
            }
        }
    }
</script>
